import React from 'react';
import { useParams } from 'react-router-dom';
import PlaylistForm from '../Create/PlaylistForm';
import { useMediaQuery } from 'react-responsive';
import DetailPlaylistMobile from './DetailPlaylistMobile';

const PlaylistDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  if (isMobile) {
    return <DetailPlaylistMobile />;
  }
  
  return (
    <PlaylistForm idPlaylist={id}/>
  );
};

export default PlaylistDetailPage;